'use client'
import { Teams } from '@glovo/organisation'
import type { FC } from 'react'
import { useEffect } from 'react'
import React from 'react'
import styles from './AddressBookDesktop.module.scss'
import { useAuth } from '@/tools/auth'
import { useErrorHandling, withErrorBoundary } from '@/tools/o11y/client'
import { useAddressBookContext } from '@/user/address-book/AddressBookContext'
import type { UserAddress, UserAddressNew } from '@/user/address-book/entities'
import { AddressDetailsForm } from '@/user/address-book/ui/steps/address-details-form/AddressDetailsForm'
import { AddressTypeForm } from '@/user/address-book/ui/steps/address-type-form/AddressTypeForm'
import { FindAddressByText } from '@/user/address-book/ui/steps/find-address-by-text/FindAddressByText'
import { SetEntrance } from '@/user/address-book/ui/steps/set-entrance/SetEntrance'
import { WhereToDeliver } from '@/user/address-book/ui/steps/where-to-deliver/WhereToDeliver'

interface Props {
  onClose: () => void
  onSelect: (address: UserAddress | UserAddressNew) => void
}

// TODO: remove this boundary when not consumed from Vue app iframe: https://glovoapp.atlassian.net/browse/WEBX-825
const AddressBookDesktopComponent: FC<Props> = ({ onClose, onSelect }) => {
  const { currentStep, setCloseAddressBook, setAddressChangeSuccess, setIsMobile, navigate } =
    useAddressBookContext()
  const { execWithErrorTracking } = useErrorHandling()
  const { isLoggedIn } = useAuth()
  const canShowFirstStep = isLoggedIn
  useEffect(() => {
    execWithErrorTracking(async () => {
      setCloseAddressBook(() => onClose)
      setAddressChangeSuccess(() => onSelect)
      setIsMobile(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, onSelect])

  useEffect(() => {
    execWithErrorTracking(async () => {
      if (!isLoggedIn) {
        navigate('onCreateNewAddress')
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <div className={styles.addressBookDesktopContainer}>
      {currentStep === 'WHERE_TO_DELIVER' && canShowFirstStep && <WhereToDeliver />}
      {currentStep === 'FIND_ADDRESS_BY_TEXT' && <FindAddressByText />}
      {currentStep === 'ADDRESS_TYPE_FORM' && <AddressTypeForm />}
      {currentStep === 'ADDRESS_DETAILS_FORM' && <AddressDetailsForm />}
      {currentStep === 'SET_ENTRANCE' && <SetEntrance />}
    </div>
  )
}

export const AddressBookDesktop = withErrorBoundary(AddressBookDesktopComponent, {
  id: 'user.address_book.root',
  owner: Teams.WEB,
})
